module.exports = __webpack_public_path__ + "img/code-analysis.30d1945c.jpeg";